import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {GlobalConstants} from './global-constants';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  connectionStatusSelectList = [
    { id: GlobalConstants.connected, name: GlobalConstants.connected },
    { id: GlobalConstants.lost, name: GlobalConstants.lost },
    { id: GlobalConstants.offline, name: GlobalConstants.offline },
    { id: GlobalConstants.notConnected, name: GlobalConstants.notConnected },
  ];
  entitlementStatusSelectList = [
    { id: 'Active', name: 'Active' },
    { id: 'Inactive', name: 'Inactive' },
  ];
  isPhysicalModelLoaded = false;
  isModelsFromDMLoaded = false;
  physicalModelListSub: any = new BehaviorSubject([]);
  modelsFromDMBehaviorSubject = new BehaviorSubject([]);
  modelSelectList = [];

  private readonly key = 'LMSencryptionKey';

  constructor(private readonly httpClient: HttpClient) { }

  getPhysicalModel(): Observable<any[]> {
    if (this.isPhysicalModelLoaded) {
      return this.physicalModelListSub.asObservable();
    } else {
      const url = environment.baseUrl + environment.getPhysicalModel;
      return this.httpClient.get<any[]>(url).pipe(
        map((res) => {
          this.physicalModelListSub.next(res);
          this.isPhysicalModelLoaded = true;
          this.getPhysicalModel();
          return res;
        })
      );
    }
  }

  getModelFromDM(): Observable<any[]> {
    if (this.isModelsFromDMLoaded) {
      return this.modelsFromDMBehaviorSubject.asObservable();
    } else {
      const url = `${environment.v2ApiBaseUrl}${environment.getDataModel}?pageNo=1&pageSize=1200`;
      return this.httpClient.get<any[]>(url).pipe(
        map((res) => {
          this.modelsFromDMBehaviorSubject.next(res);
          this.isModelsFromDMLoaded = true;
          this.getModelFromDM();
          return res;
        })
      );
    }
  }

  encrypt(plaintext: string): string {
    return CryptoJS.AES.encrypt(plaintext, this.key).toString();
  }

  decrypt(cipherText: string): string {
    if (!cipherText) {
      return null;
    }
    const bytes = CryptoJS.AES.decrypt(cipherText, this.key);
    return bytes.toString(CryptoJS.enc.Utf8);
  }

  getUsers(): Observable<any> {
    const apiUrl = environment.v2ApiBaseUrl + environment.queryApi;
    const reqBody = {
      child: 'User',
      parent: '',
      childId: '',
      parentId: '',
      projectParent: true,
      condition: { operator: 'and' },
    };
    return this.httpClient.post(apiUrl, reqBody);
  }
}
